<script setup lang="ts">
const { t } = useI18n();
const site = useSiteData();
const { localized } = useLocaleValue();

definePageMeta({
  page_name: "about",
});
</script>

<template>
  <section class="page-header">
    <div class="container">
      <h1>{{ t("about.header.title_prefix") }} {{ localized(site.website_name) }}</h1>
      <p>{{ t("about.header.subtitle") }}</p>
    </div>
  </section>

  <section class="about-content">
    <div class="container">
      <div class="about-section">
        <h2>{{ t("about.story.title") }}</h2>
        <p>{{ t("about.story.p1_prefix") }} {{ localized(site.company_name) }} {{ t("about.story.p1_suffix") }}</p>
        <p>{{ t("about.story.p2") }}</p>
      </div>

      <div class="about-section">
        <h2>{{ t("about.mission.title") }}</h2>
        <p>{{ t("about.mission.body") }}</p>
      </div>

      <div class="about-section">
        <h2>{{ t("about.values.title") }}</h2>
        <div class="values-grid">
          <div class="value-item">
            <h3>{{ t("about.values.quality_title") }}</h3>
            <p>{{ t("about.values.quality_desc") }}</p>
          </div>
          <div class="value-item">
            <h3>{{ t("about.values.price_title") }}</h3>
            <p>{{ t("about.values.price_desc") }}</p>
          </div>
          <div class="value-item">
            <h3>{{ t("about.values.shipping_title") }}</h3>
            <p>{{ t("about.values.shipping_desc") }}</p>
          </div>
          <div class="value-item">
            <h3>{{ t("about.values.custom_title") }}</h3>
            <p>{{ t("about.values.custom_desc") }}</p>
          </div>
        </div>
      </div>

      <div class="about-section">
        <h2>{{ t("about.products.title") }}</h2>
        <ul class="capabilities-list">
          <li><strong>{{ t("about.products.logo_label") }}</strong> {{ t("about.products.logo_text") }}</li>
          <li><strong>{{ t("about.products.labels_label") }}</strong> {{ t("about.products.labels_text") }}</li>
          <li><strong>{{ t("about.products.embroidery_label") }}</strong> {{ t("about.products.embroidery_text") }}</li>
          <li><strong>{{ t("about.products.location_label") }}</strong> {{ t("about.products.location_text") }}</li>
          <li><strong>{{ t("about.products.experience_label") }}</strong> {{ t("about.products.experience_text") }}</li>
        </ul>
      </div>
    </div>
  </section>
</template>
